// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__MhRNq","form":"Profile_form__5FdPo","group":"Profile_group__difdD"};